<div class="progress-bar-container">
  @if (loader.isLoading$ | async) {
    <mat-progress-bar color="accent" mode="indeterminate">
    </mat-progress-bar>
  }
</div>
